
const SellGoodsTypeModel = () => import('@/components/CSS/SellGoodsTypeModel')
import pzBadge from '@/components/pzBadge'
import { mapGetters } from 'vuex'
import { debounce } from '@/utils'
export default {
	name: 'SidebarItem',
	components: {
		SellGoodsTypeModel,
		pzBadge
	},
	data() {
		return {
			realNameModelState: false
		}
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			couponDot: 'user/couponDot'
		})
	},
	props: {
		item: {
			type: Object,
			required: true
		}
	},
	methods: {
		/**
		 * 栏目点击事件
		 */
		onSelectSubmenu: debounce(function () {
			this.$store.dispatch('user/UserCenterStatistics')
		}, 5000),
		itemHandler(child) {
			if (child.enName === 'sell') {
				this.$nextTick(async () => {
					if (this.userinfo) {
                        await this.$store.dispatch('user/UserGetInfo')
                        if(!this.userinfo.isRealName){
                            this.realNameModelState = true
                            return
                        }
					}
					this.$router.push(`/selectGame`)
					window._czc && window._czc.push(['_trackEvent', '访问量', '我要卖页面'])
				})
			}
		}
	}
}
